var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.spinning, tip: "加载中..." } },
    [
      _c(
        "a-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "a-col",
            { staticClass: "d-left", attrs: { span: "16" } },
            [
              _c("div", { staticClass: "d-header" }, [
                _c("h2", [_vm._v(_vm._s(_vm.detailData.title))]),
                _c(
                  "div",
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("datetime")(
                            _vm.detailData.publishTime,
                            "YYYY-MM-DD HH:mm"
                          )
                        ) + " "
                      )
                    ]),
                    _c("a-divider", { attrs: { type: "vertical" } }),
                    _c(
                      "span",
                      [
                        _c("a-icon", { attrs: { type: "user" } }),
                        _vm._v(" " + _vm._s(_vm.detailData.author) + " ")
                      ],
                      1
                    ),
                    _c("a-divider", { attrs: { type: "vertical" } }),
                    _c("span", [
                      _vm._v(" " + _vm._s(_vm.detailData.webName) + " ")
                    ]),
                    _c("a-divider", { attrs: { type: "vertical" } }),
                    _c("span", [
                      _c("span", { staticStyle: { "margin-right": "3px" } }, [
                        _vm._v("发布于")
                      ]),
                      _vm._v(" " + _vm._s(_vm.detailData.ipRegion) + " ")
                    ])
                  ],
                  1
                )
              ]),
              _c("a-divider"),
              _c(
                "div",
                { staticClass: "d-content" },
                [
                  _vm.detailData.fullContent
                    ? _c(
                        "div",
                        [
                          _c("TextHighlighter", {
                            attrs: {
                              text: _vm.detailData.fullContent,
                              keywords: _vm.keywords || ""
                            }
                          }),
                          _c(
                            "div",
                            { staticStyle: { "text-align": "center" } },
                            _vm._l(_vm.detailData.imgUrls, function(
                              img,
                              index
                            ) {
                              return _c(
                                "p",
                                {
                                  key: index,
                                  staticStyle: { "margin-bottom": "20px" }
                                },
                                [
                                  _c("img", {
                                    staticStyle: { "max-width": "100%" },
                                    attrs: { src: img, alt: "" }
                                  })
                                ]
                              )
                            }),
                            0
                          )
                        ],
                        1
                      )
                    : _c("a-empty")
                ],
                1
              )
            ],
            1
          ),
          _c("a-col", { staticClass: "d-right", attrs: { span: "8" } }, [
            _c("div", { staticClass: "right-header" }, [
              _c("h3", [_vm._v("原文链接")]),
              _vm.detailData.url
                ? _c("div", [
                    _c(
                      "a",
                      { attrs: { href: _vm.detailData.url, target: "_blank" } },
                      [
                        _c("Ellipsis", {
                          attrs: {
                            text: _vm.detailData.url,
                            "max-length": 40,
                            symbol: "."
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "a",
                      {
                        staticStyle: { "margin-left": "10px" },
                        on: {
                          click: function($event) {
                            return _vm.copy(_vm.detailData.url)
                          }
                        }
                      },
                      [_vm._v("复制")]
                    )
                  ])
                : _vm._e()
            ]),
            _c("div", { staticClass: "right-center" }, [
              _c("div", { staticClass: "d-region" }, [
                _c("h3", [_vm._v("涉及地域")]),
                _c("div", [
                  _c(
                    "p",
                    [
                      _c("span", { staticClass: "region-label" }, [
                        _vm._v(" 发布于：")
                      ]),
                      _c("a-tag", [
                        _vm._v(" " + _vm._s(_vm.detailData.ipRegion) + " ")
                      ])
                    ],
                    1
                  ),
                  _c("p", [
                    _c("span", { staticClass: "region-label" }, [
                      _vm._v(" 发布地点：")
                    ]),
                    _vm._v(_vm._s(_vm.detailData.postPlace))
                  ]),
                  _c(
                    "p",
                    [
                      _c("span", { staticClass: "region-label" }, [
                        _vm._v(" 作者地域：")
                      ]),
                      _vm._l(_vm.detailData.authorCptLocation, function(item) {
                        return _c("a-tag", { key: item }, [
                          _vm._v(" " + _vm._s(item) + " ")
                        ])
                      })
                    ],
                    2
                  )
                ])
              ])
            ]),
            _c("div", { staticClass: "right-footer" }, [
              _c("div", { staticClass: "author-info" }, [
                _c(
                  "div",
                  [
                    _c("a-avatar", {
                      attrs: { size: 64, src: _vm.detailData.authorAvatar }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticStyle: { "margin-left": "16px" } },
                  [
                    _c("div", { staticClass: "footer-author" }, [
                      _vm._v(_vm._s(_vm.detailData.author))
                    ]),
                    _c(
                      "a-row",
                      [
                        _c("a-col", { attrs: { span: 12 } }, [
                          _vm._v(
                            " 粉丝： " +
                              _vm._s(
                                _vm.detailData.authorInfo &&
                                  _vm.detailData.authorInfo.authorFansCount
                              ) +
                              " "
                          )
                        ]),
                        _c("a-col", { attrs: { span: 12 } }, [
                          _vm._v(
                            "关注： " +
                              _vm._s(
                                _vm.detailData.authorInfo &&
                                  _vm.detailData.authorInfo.authorFriendsCount
                              )
                          )
                        ]),
                        _c("a-col", { attrs: { span: 12 } }, [
                          _vm._v(
                            "获赞： " +
                              _vm._s(
                                _vm.detailData.authorInfo &&
                                  _vm.detailData.authorInfo.authorLikeCount
                              ) +
                              " "
                          )
                        ]),
                        _c("a-col", { attrs: { span: 12 } }, [
                          _vm._v(
                            "作品： " +
                              _vm._s(
                                _vm.detailData.authorInfo &&
                                  _vm.detailData.authorInfo.authorWorksNum
                              )
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm.detailData.authorInfo &&
              _vm.detailData.authorInfo.authorSourceId
                ? _c("div", { staticStyle: { "margin-top": "20px" } }, [
                    _vm._v(
                      " 账号ID：" +
                        _vm._s(_vm.detailData.authorInfo.authorSourceId) +
                        " "
                    )
                  ])
                : _vm._e(),
              _vm.detailData.authorInfo && _vm.detailData.authorInfo.ipregion
                ? _c("div", { staticStyle: { "margin-top": "10px" } }, [
                    _vm._v(
                      " IP属地：" +
                        _vm._s(_vm.detailData.authorInfo.ipregion) +
                        " "
                    )
                  ])
                : _vm._e()
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }